import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/*
 * FCM 푸시 수신 이벤트 버스.
 *
 * 푸시가 오면 코드(d_v2ReservationCreate_el 등)에 해당하는 칸에 payload 를 꽂는다.
 * 화면은 그 칸을 watch 하고 있다가 갱신한다.
 *
 * 칸을 여기 전부 미리 적어 두는 이유: Vue 2 는 나중에 더한 키를 감지하지 못한다.
 * 목록에 없는 코드로 꽂으면 값은 들어가지만 아무 화면도 반응하지 않는다.
 */

export type PushEvent =
    | { data?: { code?: string; hospitalID?: string; [extra: string]: unknown }; [extra: string]: unknown }
    | undefined

const state = {
    d_HServiceCreate_el: undefined as PushEvent,
    d_HServiceUpdate_el: undefined as PushEvent,
    d_VCUCreate_el: undefined as PushEvent,
    d_ChatroomUpdateVCU_el: undefined as PushEvent,
    d_ServiceNoticeCreate_el: undefined as PushEvent,
    d_MemoCreate_an: undefined as PushEvent,
    d_ServiceNoticeCreateMemo_an: undefined as PushEvent,
    d_HServiceSuspend_el: undefined as PushEvent,
    d_MemoCreate_h: undefined as PushEvent,
    d_MemoUpdate_an: undefined as PushEvent,
    d_MemoUpdate_h: undefined as PushEvent,
    d_ServiceNoticeCreateMemo_h: undefined as PushEvent,
    d_MemoUpdate_el: undefined as PushEvent,
    d_RSDNUpdate_el: undefined as PushEvent,
    d_ReservationCreate_el: undefined as PushEvent,
    d_ReservationUpdate_el: undefined as PushEvent,
    d_ReservationRemove_el: undefined as PushEvent,
    d_RBCreate_el: undefined as PushEvent,
    d_RBUpdate_el: undefined as PushEvent,
    d_RBRemove_el: undefined as PushEvent,
    d_RUNUpdate_el: undefined as PushEvent,
    d_RVCreate_el: undefined as PushEvent,
    d_ChatroomUpdate_el: undefined as PushEvent,
    d_ChatroomUpdate_an: undefined as PushEvent,
    d_ChatroomUpdateDoctor_el: undefined as PushEvent,
    d_ChatroomUpdateChattingReservation_el: undefined as PushEvent,
    d_UserUpdate_el: undefined as PushEvent,
    d_ServiceNoticeCreateReservation_el: undefined as PushEvent,
    d_Timer_el: undefined as PushEvent,
    d_RSUpdate_el: undefined as PushEvent,
    m_ChatroomUpdateVCU_el: undefined as PushEvent,
    m_HServiceUpdateDoctor_el: undefined as PushEvent,
    m_MemoCreate_an: undefined as PushEvent,
    m_MemoUpdate_an: undefined as PushEvent,
    m_MemoCreate_h: undefined as PushEvent,
    m_HServiceUpdate_el: undefined as PushEvent,
    m_ChatroomUpdate_el: undefined as PushEvent,
    m_ChatroomUpdateDoctor_el: undefined as PushEvent,
    m_HServiceUpdateAuth_el: undefined as PushEvent,
    m_ReservationCreate_el: undefined as PushEvent,
    m_ReservationUpdate_el: undefined as PushEvent,
    m_ReservationRemove_el: undefined as PushEvent,
    m_Timer_el: undefined as PushEvent,
    m_ChatroomUpdateResponseRequired_h: undefined as PushEvent,
    d_ChatroomUpdateResponseRequired_h: undefined as PushEvent,

    m_v2ReservationCreate_el: undefined as PushEvent,
    m_v2ReservationUpdate_el: undefined as PushEvent,
    m_v2ReservationCancel_el: undefined as PushEvent,
    m_v2ReservationRemove_el: undefined as PushEvent,

    d_v2ReservationCreate_el: undefined as PushEvent,
    d_v2ReservationUpdate_el: undefined as PushEvent,
    d_v2ReservationCancel_el: undefined as PushEvent,
    d_v2ReservationRemove_el: undefined as PushEvent,

    d_v2ReservationSettingUpdate_el: undefined as PushEvent,

    d_v2ReservationGroupCreate_el: undefined as PushEvent,
    d_v2ReservationGroupUpdate_el: undefined as PushEvent,
    d_v2ReservationGroupRemove_el: undefined as PushEvent,
    d_v2ReservationColumnCreate_el: undefined as PushEvent,
    d_v2ReservationColumnUpdate_el: undefined as PushEvent,
    d_v2ReservationColumnRemove_el: undefined as PushEvent,

    d_v2ReservationStatusUpdateSort_el: undefined as PushEvent,
    d_v2ReservationProgramUpdateSort_el: undefined as PushEvent,
    d_v2ReservationGroupUpdateSort_el: undefined as PushEvent,
    d_v2ReservationColumnUpdateSort_el: undefined as PushEvent,

    d_v2ReservationBlockCreate_el: undefined as PushEvent,
    d_v2ReservationBlockUpdate_el: undefined as PushEvent,
    d_v2ReservationBlockRemove_el: undefined as PushEvent,

    d_v2ReservationCellCreate_el: undefined as PushEvent,
    d_v2ReservationCellUpdate_el: undefined as PushEvent,
    d_v2ReservationCellRemove_el: undefined as PushEvent,

    d_v2WorkRecordUpdateBatch_el: undefined as PushEvent,

    d_v2WorkHolidayCreate_el: undefined as PushEvent,
    d_v2WorkHolidayRemove_el: undefined as PushEvent,

    d_Logout_el: undefined as PushEvent,
}

export type RemoteNotificationState = typeof state

type Store = { commit(type: string, payload: unknown): void }

type PushParam = { key: keyof RemoteNotificationState; value: PushEvent }

const actions = {
    'AC_UpdatePushNotificationValue': (store: Store, param: PushParam): void => {
        console.log(param)
        store.commit('MU_UpdatePushNotificationValue', param)
    },
}

const mutations = {
    'MU_UpdatePushNotificationValue': (state: RemoteNotificationState, param: PushParam): void => {
        state[param.key] = param.value
    },
}

const remote_notification: Module<RemoteNotificationState, StoreState> = { state, actions, mutations }

export default remote_notification
